@use '@design/design-tokens/typography/typography' as *;
@use '@design/design-tokens/border-radius/border-radius' as *;

.iconWrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  @include border-radius-full;
  padding: 2px;
  width: 16px;
  height: 16px;
  background-color: var(--surface-default);

  &.CompanyCatalyst {
    background-color: var(--surface-decorative-lime-default);
  }

  &.MarketCatalyst {
    background-color: var(--surface-decorative-cyan-default);
  }

  &.MarketSummary {
    background-color: var(--surface-decorative-gold-default);
  }

  &.Scenario {
    background-color: var(--surface-decorative-indigo-default);
  }

  &.EarningsPreview {
    background-color: var(--surface-decorative-purple-default);
  }

  &.EarningsRecap {
    background-color: var(--surface-decorative-teal-default);
  }
}

.titleLabel {
  @include typography-v2-ui-sm;
  white-space: nowrap;

  &.CompanyCatalyst {
    color: var(--text-decorative-lime);
  }

  &.MarketCatalyst {
    color: var(--text-decorative-cyan);
  }

  &.MarketSummary {
    color: var(--text-decorative-gold);
  }

  &.Scenario {
    color: var(--text-decorative-indigo);
  }

  &.EarningsPreview {
    color: var(--text-decorative-purple);
  }

  &.EarningsRecap {
    color: var(--text-decorative-teal);
  }
}

.styledPillWrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
}

.styledScenarioIcon {
  > path {
    fill: var(--icon-decorative-indigo);
  }
}
